export default "__VITE_ASSET__DxoXXbEX__"